import { render, staticRenderFns } from "./ABuscarProgramas.vue?vue&type=template&id=0f8c7fac"
import script from "./ABuscarProgramas.vue?vue&type=script&lang=js"
export * from "./ABuscarProgramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports